import { Descriptions } from 'antd';
import React from 'react';
import SkeletonInput from 'antd/es/skeleton/Input';

const ReceivingReportLoadingView = ({ active }: { active: boolean }) => {
  return (
    <>
      <Descriptions title="Material Request">
        <Descriptions.Item label="Code">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Required Date">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Source Document">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Destination">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Notes">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <SkeletonInput active={active} />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};
export default ReceivingReportLoadingView;
